// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"2df4e886","387":"2e2a2747","434":"0ce90c07","540":"d433d38f","588":"f8b41284","693":"74e8d03b","738":"0216f222","800":"c0dde659"}[chunkId] + ".chunk.js";
};